module.exports = __webpack_public_path__ + "img/mobile-app.d23c87bb.png";